import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M5.50002 10C7.9853 10 10 7.9853 10 5.50002C10 3.01472 7.9853 1 5.50002 1C3.01472 1 1 3.01472 1 5.50002C1 7.9853 3.01472 10 5.50002 10Z"
      fill={props?.fill || 'white'}
      stroke={props?.stroke || '#383838'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3569 11.3574L8.35693 9.35742"
      stroke={props?.stroke || '#383838'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const SearchIcon = memo(ForwardRef);
export default SearchIcon;
